import { UserBetaFeaturesResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type UserBetaFeaturesResponseInput = z.input<typeof UserBetaFeaturesResponseSchema>;
export type UserBetaFeaturesResponseOutput = z.output<typeof UserBetaFeaturesResponseSchema>;

export function serializeUserBetaFeaturesResponse(
  payload: UserBetaFeaturesResponseInput
): UserBetaFeaturesResponseOutput {
  return UserBetaFeaturesResponseSchema.parse(payload);
}
